export { default } from './MobileProductPriceAvailability'
